import { useEffect, useState } from "react";
import styles from './customerCleaner.module.css';
import { useNavigate } from "react-router-dom";
import { List } from "antd";
import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import { GoPrimitiveDot } from 'react-icons/go';
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from '../../../assets/dummy.png';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AntdDropdown, SearchInput } from "../../../components";
import { FiSearch } from "react-icons/fi";
import CustomerCleanerMiddleware from '../../../store/Middlewares/CustomerCleanerMiddleware'

const CustomerCleaner = () => {
  const [search, setsearch] = useState();
  const navigate = useNavigate();

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();

  const category = useSelector(state => state.CategoriesReducer.CategoryList);
  const CustomerCleanerLIST = useSelector(
    state => state.CustomerCleanerReducer.CustomerCleanerList,
  );

  const CustomerCleanerPagination = useSelector(
    state => state.CustomerCleanerReducer.CustomerCleanerPagination,
  );

  const [SelectedId, setSelectedId] = useState('');

  const getCustomerCleaner = () => {
    let response = {
      Search: search,
      next_page_url: undefined,
      Id: SelectedId,
    };
    dispatch(CustomerCleanerMiddleware.getCustomerCleaner(response));
  };

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories());
  };

  useEffect(() => {
    getCustomerCleaner();
    getCategories();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };



  const onPressLoadMore = () => {
    let response = {
      Search: search,
      next_page_url: CustomerCleanerPagination?.links?.next,
      Id: SelectedId,
    };
    dispatch(CustomerCleanerMiddleware.getCustomerCleaner(response));
  };

  const loadMore =
    CustomerCleanerPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/Cleaners/ActiveCleaners/Profile", {
            state: { item, screen: 'customerCleaner' },
          })
        }
      >
        <div style={{display:'flex',flexDirection:'row',width:'100%'}}>
          <img src={item?.cleaner_image ? IMG_URL + item?.cleaner_image : dummyImg} className={styles.image} />
          <div className={styles.heading_view}>
            <text className={styles.tab_heading}> {item?.cleaner_name}</text>
            <text className={styles.text}>{t(item?.service_type)}</text>
          </div>
        </div>
        {/* </div> */}
        <div className={styles.assignedDiv}>
          <GoPrimitiveDot className={styles.dot} color={item?.status == 'working' ? '#56F71E' : '#707070'} />

        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Cleaners")}</h1>
      </div>
      <div className={styles.filter_view}>
        <div style={{ width: '100%', margin: '12px 10px 12px 0px', }}>
          <input
            placeholder={t("Search")}
            onChange={(e) => setsearch(e.target.value)}
            className={styles.search_input}
          />
        </div>
        <div className={styles.flex} style={{ margin: '10px 0px' }}>
          <div>
            <AntdDropdown
              name={'Status'}
              // label={'Role'}
              className={'yellow_border_class'}
              placeholder={t('Select Category')}
              onChange={(val) => setSelectedId(val)}
              options={category?.map((item) => { return { value: item?.id, option: t(item?.name) } })}
              style={{ width: '200px', height: '20px', borderColor: 'red' }}
            />
          </div>
          <div>
            <button onClick={getCustomerCleaner} className={styles.search_button}>
              <FiSearch size={20} color={"#fff"} />
            </button>
          </div>
        </div>
      </div>
      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={CustomerCleanerLIST}
        footer={loadMore}
        renderItem={renderItem}
      />
    </div>
  )
};
export default CustomerCleaner;